import { render, staticRenderFns } from "./BuildingListStatistica.vue?vue&type=template&id=2335378c&scoped=true&"
import script from "./BuildingListStatistica.vue?vue&type=script&lang=js&"
export * from "./BuildingListStatistica.vue?vue&type=script&lang=js&"
import style0 from "./BuildingListStatistica.vue?vue&type=style&index=0&id=2335378c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2335378c",
  null
  
)

export default component.exports